import React from "react";
import { Datagrid, DeleteButton, EditButton, List, Loading, TextField, TextInput, useMutation, useRedirect } from "react-admin";

import { PERMISSION_LIST_SIGNET, SignetRingDataResources } from "../util";
import ListActions from "../ListActions";


const CustomEdit = ({ record: { id } }) => {
    const redirect = useRedirect();
    const [getDetails] = useMutation({
        type: "getOne",
        resource: SignetRingDataResources,
        payload: { id: id }
    });

    const handleEdit = async e => {
        e.preventDefault();
        getDetails();
        redirect(`/${SignetRingDataResources}/${id}`);
    };

    return <EditButton onClick={handleEdit} />;
};

const SignetRingList = props => {
    const { permissions } = props;

    if (!permissions) return <Loading />;
    const permissionsList = permissions.split(",");
    return (
        <List
            {...props}
            exporter={false}
            sort={false}
            actions={<ListActions filters={
                [<TextInput source="shape" label="Shape" defaultValue="" />,
                <TextInput source="size" label="Size" defaultValue="" />,
                <TextInput source="shank" label="Shank" defaultValue="" />]
            } />}
        >
            <Datagrid rowClick={null}>
                <TextField source="shape" label="Shape" />
                <TextField source="size" label="Size" />
                <TextField source="shank" label="Shank" />
                <TextField source="allow_machine_pattern" sortable={false} label="LCV" />

                <TextField source="allow_inlay" sortable={false} label="Allow Inlay" />
                <TextField source="first_finish_group" sortable={false} label="First Finish Group" />
                <TextField source="second_finish_group" sortable={false} label="Second Finish Group" />
                <TextField source="inlay_finish_group" sortable={false} label="Inlay Finish Group" />


                {permissionsList.includes("delete_signet_data") && <CustomEdit />}
                {permissionsList.includes(PERMISSION_LIST_SIGNET.delete_signet_data) && (
                    <DeleteButton label="" undoable={false} />
                )}
            </Datagrid>
        </List>
    );
};

export default SignetRingList;